import ReactBackdrop from "@mui/material/Backdrop";
import withStyles from '@mui/styles/withStyles';

export const Overlay = withStyles(theme => {
    return {
        root: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
    }
})(ReactBackdrop);